function getCookie(name) {
  if (!name || typeof name !== 'string') {
    throw new TypeError('Cookie name must be a non-empty string')
  }

  const match = document.cookie.match(new RegExp(
    '(?:^|;)\\s*' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'
  ))

  return match ? decodeURIComponent(match[1]) : null
}

function checkCorporateCookie() {
  const urls = ["https://shop.unicef.org.nz/", "http://localhost:9292/"];
  if (urls.includes(window.location.href)) {
    if (getCookie("isCorporate")) {
      window.location.href = `${window.location.href}pages/corporate-gifts`;
    }
  }
}

function setCorporateCookie(corporateGift) {
  if (corporateGift) {
    const d = new Date();
    d.setTime(d.getTime() + 30 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = 'isCorporate=true;' + expires + ';path=/';
  }
}

document.addEventListener("DOMContentLoaded", function () {
  checkCorporateCookie();
});
